import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Home.css";
import SEO from '../SEO/SEO';
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ServiceAreaSections from "./ServiceAreaSections";
import { Link, NavLink } from "react-router-dom";
import chooseUsImg from "../Assets/choose-us-img.png";
import icon1 from "../Assets/choose-us-icon-1.png";
import icon2 from "../Assets/choose-us-icon-2.png";
import icon3 from "../Assets/choose-us-icon-3.png";
import icon4 from "../Assets/choose-us-icon-4.png";
import icon5 from "../Assets/choose-us-icon-5.png";
import icon6 from "../Assets/choose-us-icon-6.png";
import bubbleBg from "../Assets/bubble-img.png";
import step1 from "../Assets/quotes.png";
import step2 from "../Assets/calender.png";
import step3 from "../Assets/brush.png";
import step4 from "../Assets/smile.png";
import aboutImg from "../Assets/housekeeper.jpg";
import aboutSatisfiedIcon from "../Assets/about-satisfied-icon.png";
import aboutIcon from "../Assets/about-icon.png";
import Google from "../Assets/Google.png";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import { FaCalculator } from "react-icons/fa6";
// import { FaStar } from "react-icons/fa";
import { FaRegSmile } from "react-icons/fa";
import SuccessPopup from './../thankyoupop/thankyoupop'; // Adjust path as needed
import api, { PUBLIC_BASE_URL } from "../Api/api";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OpenCageAutocomplete from "../OpenCageAutocomplete";

const features = [
  {
    icon: icon1,
    title: "Customer Satisfaction",
    desc: "Your happiness is our ultimate goal– we back our services with a satisfaction guarantee...",
  },
  {
    icon: icon2,
    title: "High Quality Equipments",
    desc: "Equipped with state-of-the-art tools and technology, ‘Shiny Cleaning’ delivers unmatched results...",
  },
  {
    icon: icon3,
    title: "Affordable pricing",
    desc: "Affordability meets excellence, offering competitive pricing that doesn’t compromise quality.",
  },
  {
    icon: icon4,
    title: "Well Trained Staff",
    desc: "Our well-trained staff ensures expert care and attention to every detail in cleaning tasks.",
  },
  {
    icon: icon5,
    title: "Best Customer Service",
    desc: "Experience warmth and priority-focused customer service with us.",
  },
  {
    icon: icon6,
    title: "Public Liability Insurance",
    desc: "We are fully insured—giving you peace of mind during our services.",
  },
];

const steps = [
  {
    icon: step1,
    label: "Step 1",
    title: "Get Free Quote",
    desc: "Contact us online or give us a call for a free quote.",
  },
  {
    icon: step2,
    label: "Step 2",
    title: "Booked Appointment",
    desc: "Schedule your appointment hassle-free online or by call.",
  },
  {
    icon: step3,
    label: "Step 3",
    title: "Provide Service",
    desc: "We deliver your requested service directly to your doorstep.",
  },
  {
    icon: step4,
    label: "Step 4",
    title: "Let’s Relax",
    desc: "Enjoy peace of mind knowing your space is in expert hands.",
  },
];

const Home = () => {
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);


  // useEffect(()=>{
  //   setShowSuccessPopup(true);
  // })
  //api connect start

  useEffect(() => {
    const carouselElement = document.querySelector("#servicesCarousel");
    if (carouselElement) {
      new window.bootstrap.Carousel(carouselElement, {
        interval: 4000,
        ride: "carousel",
      });
    }
  }, []);

  const inputRef = useRef(null);

  useEffect(() => {
    if (!window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["geocode"],
        componentRestrictions: { country: "au" }, // restrict to Australia
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      console.log("Selected place:", place);
      // You can also set the selected value to a state
    });
  }, []);

  const [slides, setSlides] = useState([]);

  useEffect(() => {
    api
      .get("hero-carousel")
      .then((res) => {
        setSlides(res.data);
      })
      .catch((err) => console.error("Failed to fetch slides", err));
  }, []);

  const [services, setServices] = useState([]);

  useEffect(() => {
    api
      .get("premium-services") // update to your API URL
      .then((response) => {
        setServices(response.data);
      })
      .catch((error) => {
        console.error("Error fetching services:", error);
      });
  }, []);

  const [stats, setStats] = useState([]);

  useEffect(() => {
    api
      .get("statbox") // Update to your Laravel URL if hosted
      .then((res) => {
        setStats(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch stats", err);
      });
  }, []);

  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("testimonials").then((res) => {
      setTestimonials(res.data.testimonials);
    });
  }, []);

  const [scrollIndex, setScrollIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3);
  const scrollRef = useRef();
  const CARD_WIDTH = 300 + 16; // width + margin

  useEffect(() => {
    const updateVisibleCards = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setVisibleCards(1);
      } else if (width < 768) {
        setVisibleCards(1);
      } else if (width < 992) {
        setVisibleCards(2);
      } else {
        setVisibleCards(3);
      }
    };

    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  const scroll = (direction) => {
    const maxIndex = Math.ceil(testimonials.length / visibleCards) - 1;
    let newIndex = scrollIndex;

    if (direction === "left") {
      newIndex = Math.max(0, scrollIndex - 1);
    } else if (direction === "right") {
      newIndex = Math.min(maxIndex, scrollIndex + 1);
    }

    setScrollIndex(newIndex);

    if (scrollRef.current) {
      scrollRef.current.style.transform = `translateX(-${
        newIndex * CARD_WIDTH * visibleCards
      }px)`;
    }
  };
  const renderStars = (count) =>
    Array.from({ length: count }, (_, i) => (
      <b key={i} className="fa-solid fa-star" style={{ color: "gold" }}>
        ★
      </b>
    ));

  const [reviewCount, setReviewCount] = useState(null);

  useEffect(() => {
    api
      .get("google-review-count")
      .then((res) => {
        if (res.data) {
          setReviewCount(res.data.review_count);
        }
      })
      .catch((err) => {
        console.error("Error fetching Google Review Count:", err);
      });
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    address: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState(""); // success or error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    const response = await api.post("/contact-submit", formData, {
      headers: { "Content-Type": "application/json" },
    });

    if (response.data.success) {
      setShowSuccessPopup(true);

      // ✅ WhatsApp message send
      const phoneNumber = "61406958557"; // Replace with your WhatsApp number
      const message = encodeURIComponent(
        `New Lead from Reach Out Form Submission:\n
Name: ${formData.name}\n
Email: ${formData.email}\n
Phone: ${formData.phone}\n
Address: ${formData.address}\n
City: ${formData.city}\n
Message: ${formData.message}`
      );

      const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;
      // window.open(whatsappLink, "_blank"); // opens WhatsApp with message

      // ✅ Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        city: "",
        address: "",
        message: "",
        captcha: "",
      });
    } else {
      toast.error("❌ Submission failed. Please try again.");
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("❌ An error occurred. Please check the console.");
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div>
      {/* <SEO /> */}

      <Header />

      <section className="hero-carousel position-relative text-white text-center d-flex align-items-center justify-content-center">
        <div
          id="heroVideoCarousel"
          className="carousel slide carousel-fade w-100"
          data-bs-ride="carousel"
          data-bs-interval="3000"
        >
          <div className="carousel-inner">
            {slides.map((slide, index) => {
              const isActive = index === 0 ? "active" : "";
              const mediaUrl = PUBLIC_BASE_URL + slide.media;

              return (
                <div
                  key={index}
                  className={`carousel-item ${isActive} position-relative`}
                >
                  {slide.media_type === "video" ? (
                    <video
                      className="bg-video w-100"
                      style={{ height: "100vh", objectFit: "cover" }}
                      autoPlay
                      muted
                      loop
                      playsInline
                      preload="metadata"
                      poster="thumbnail.jpg"
                    >
                      <source src={mediaUrl} type="video/mp4" />
                    </video>
                  ) : (
                    <img
                      src={mediaUrl}
                      className="bg-video w-100"
                      style={{ height: "100vh", objectFit: "cover" }}
                      alt="Slide"
                    />
                  )}

                  <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"></div>

                  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center px-3">
                    <div className="container">
                      <div className="cleaning-card bg-dark bg-opacity-75 text-white rounded-4 shadow p-5">
                        <div className="text-content">
                          <h2 className="fw-bold mb-3 text-white">
                            {slide.heading}
                          </h2>
                          <p className="mb-4 text-white">{slide.paragraph}</p>

                          <div className="d-flex flex-row flex-wrap align-items-start justify-content-start gap-4 pt-3 border-top border-light">
                            {slide.happy_customers && (
                              <div className="d-flex align-items-start gap-3">
                                <FaRegSmile className="text-white fs-3" />
                                <div>
                                  <h5 className="mb-0 fw-bold text-white">
                                    {slide.happy_customers}
                                  </h5>
                                  <small className="text-white">
                                    Happy Customers
                                  </small>
                                </div>
                              </div>
                            )}

                            {slide.rating && (
                              <div className="d-flex align-items-center gap-3 border-start border-light ps-3">
                                <div>
                                  <h5 className="mb-0 fw-bold text-white">
                                    {slide.rating}
                                  </h5>
                                  <div className="text-warning small d-flex">
                                    {Array.from({ length: 5 }).map((_, i) => {
                                      const rating = slide.rating || 0;
                                      if (rating >= i + 1) {
                                        return <FaStar key={i} />;
                                      } else if (rating > i && rating < i + 1) {
                                        return <FaStar key={i} />;
                                      } else {
                                        return <FaStar key={i} />;
                                      }
                                    })}
                                  </div>

                                  <small className="text-white">Rating</small>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="quote-buttons d-flex flex-column flex-sm-row justify-content-center justify-content-md-start gap-3 mt-4">
                            <Link
                              to="/free-quote"
                              className="btn btn-outline-info text-white d-inline-flex align-items-center gap-2 justify-content-center"
                            >
                              <FaCalculator />Get Free Quote 
                            </Link>
                            <Link
                              to="tel:0406958557"
                              className="btn btn-outline-primary text-white d-inline-flex align-items-center gap-2 justify-content-center"
                            >
                             <FaPhoneAlt /> Call Now 
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="our-services-section py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold" style={{ color: "#001070" }}>
              PREMIUM <span style={{ color: "#0a62a9" }}>SERVICES</span>
            </h2>
            <p className="">Because every space deserves perfection.</p>
          </div>

          <div className="row g-4">
            {services.map((service, index) => (
              <div className="col-12 col-md-6 col-lg-4" key={index}>
                <div className="card service-card h-100 shadow-sm border-0">
                  <Link to={service.route}>
                    <div className="service-img-wrapper">
                      <img
                        src={`${PUBLIC_BASE_URL}${service.image}`}
                        alt={service.title}
                        className="card-img-top service-img"
                      />
                      <div className="service-overlay">
                        <h5 className="fw-bold service-title mb-0">
                          {service.title}
                        </h5>
                      </div>
                    </div>
                  </Link>
                  <div className="card-body">
                    <p className="text-muted mb-0">{service.description}</p>
                  </div>
                  <div className="px-3 pb-3">
                    <Link
                      to={service.route}
                      className="btn btn-outline-primary"
                      style={{ borderRadius: "30px" }}
                    >
                      View More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Area Sections */}
      <ServiceAreaSections />

      <section
        className="why-choose-us py-5 text-white"
        style={{
          backgroundColor: "#0e3c77",
          backgroundImage: `url(${bubbleBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right top",
        }}
      >
        <div className="container">
          <div className="row">
            {/* Left Content */}
            <div className="col-lg-8">
              <h5 className="section-subtitle">— WHY CHOOSE US</h5>
              <h2 className="section-titlewhy mb-4">
                Why You Should Hire Shiny Cleaners?
              </h2>
              <div className="row g-4 mt-4">
                {features.map((item, index) => (
                  <div className="col-sm-6 d-flex" key={index}>
                    <div className="icon me-5">
                      <img src={item.icon} alt="icon" width="40" className="" />
                    </div>
                    <div>
                      <h6 className="fw-bold">{item.title}</h6>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Image */}
            <div className="col-lg-4 col-md-6 col-sm-12 text-center mt-4 d-flex align-items-end justify-content-center">
              <img
                src={chooseUsImg}
                alt="Shiny Cleaner"
                className="img-fluid"
                style={{
                  maxHeight: "550px",
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="text-center my-5">
        <h2 style={{ color: "#13356F", fontWeight: 600 }}>
          Our Working Process
        </h2>
      </section>

      <section className="step-process py-5">
        <div className="container">
          <div className="row justify-content-center g-4">
            {steps.map((step, index) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={index}>
                <div className="step-card p-4 h-100 d-flex flex-column align-items-center text-center">
                  <div className="step-icon mb-3">
                    <img src={step.icon} alt={`Icon ${step.label}`} />
                    <p className="step-label mt-2">{step.label}</p>
                  </div>
                  <div className="step-box">
                    <h4 className="step-title">{step.title}</h4>
                    <p className="step-desc">{step.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-section py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Column - Image */}
            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
              <div className="position-relative p-2 p-md-3">
                <img
                  src={aboutImg}
                  alt="Cleaning Woman"
                  className="about-image rounded w-100 object-fit-cover"
                />

                {/* Responsive Badge */}
                <div className="badge-box d-flex align-items-center gap-2 bg-white shadow rounded px-3 py-2 position-absolute">
                  <img
                    src={aboutSatisfiedIcon}
                    alt="Satisfied Icon"
                    className="icon"
                  />
                  <div>
                    <strong className="fs-5">2500+</strong>
                    <p className="mb-0 small text-muted">
                      Satisfied <br /> Customers
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Content */}
            {/* Right Column - Content */}
            <div className="col-12 col-lg-6">
              <h3 className="section-subtitle text-primary fw-semibold mb-2">
                — About Shiny Cleaning
              </h3>
              <h2 className="section-title fw-bold mb-3">
                Adelaide & Melbourne’s Trusted Choice for Superior Cleaning
                Services
              </h2>
              <h4 className="section-highlight text-secondary mb-4">
                Delivering Sparkling Results — From Homes to Commercial Spaces
              </h4>
              <p className="section-description text-muted">
                Shiny Cleaning is your local expert for professional cleaning
                services in Adelaide and Melbourne, committed to creating
                spotless, healthy environments for homes, offices, and
                commercial facilities. With over 10 years of experience, we
                proudly serve as the leading name in both house cleaning
                services in Adelaide and Melbourne, known for our reliable
                service, attention to detail, and eco-conscious methods.
              </p>
              <p className="section-description text-muted">
                <strong>
                  We offer a full spectrum of cleaning solutions, including:
                </strong>{" "}
                <br />
                ✅ Once-off house cleaning service in Adelaide – perfect for
                special occasions or seasonal refreshes
                <br />
                ✅Regular house cleaning service in Adelaide – reliable weekly,
                fortnightly, or monthly care
                <br />
                ✅End of lease cleaning service in Adelaide – stress-free bond
                cleaning to help you move out with confidence
                <br />
                ✅Deep house cleaning service in Adelaide – thorough cleaning
                that targets hidden grime and allergens
                <br />
                ✅Commercial cleaning services in Adelaide & Melbourne –
                professional-grade cleanliness for all business types
                <br />
                ✅Office cleaning services in Adelaide – tailored cleaning plans
                for workspaces of all sizes
                <br />
                ✅Aged care cleaning service in Adelaide – hygienic and
                compassionate care for sensitive environments
                <br />
                ✅School cleaning services in Adelaide – safe, dependable
                cleaning for educational facilities
                <br />
                ✅Medical centre cleaning service in Adelaide – compliant and
                sanitized spaces for healthcare settings
                <br />
              </p>
              <p className="section-description text-muted">
                Our highly trained staff uses industry-approved tools and
                eco-friendly cleaning products to ensure every space is cleaned
                to the highest standards—safely and sustainably. Whether you're
                a homeowner, property manager, or business owner, Shiny Cleaning
                is dedicated to your satisfaction. We provide timely service,
                honest pricing, and a free quote within 24 hours.
              </p>

              {/* Feature List */}
              <div className="row mt-4">
                <div className="col-12 col-sm-6">
                  <ul className="list-unstyled mb-0">
                    <li className="d-flex align-items-center mb-2">
                      <img src={aboutIcon} alt="icon" className="me-2" />
                      100% Satisfaction Guarantee
                    </li>
                    <li className="d-flex align-items-center mb-2">
                      <img src={aboutIcon} alt="icon" className="me-2" />
                      Public Liability Insurance
                    </li>
                    <li className="d-flex align-items-center mb-2">
                      <img src={aboutIcon} alt="icon" className="me-2" />
                      Affordable Pricing
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-sm-6">
                  <ul className="list-unstyled mb-0">
                    <li className="d-flex align-items-center mb-2">
                      <img src={aboutIcon} alt="icon" className="me-2" />
                      Well-Trained & Vetted Staff
                    </li>
                    <li className="d-flex align-items-center mb-2">
                      <img src={aboutIcon} alt="icon" className="me-2" />
                      Exceptional Customer Service
                    </li>
                    <li className="d-flex align-items-center mb-2">
                      <img src={aboutIcon} alt="icon" className="me-2" />
                      Eco-Friendly Practices
                    </li>
                  </ul>
                </div>
              </div>

              {/* Read More Button */}
              <Link
                to="/about-us/"
                className="btn btn-outline-primary mt-4 d-inline-block"
                style={{ borderRadius: "30px" }}
              >
                READ MORE
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section py-5">
        <div className="container">
          <div className="row text-center g-4">
            {stats.map((stat, index) => (
              <div key={index} className="col-12 col-sm-6 col-lg-3">
                <div className="stat-box shadow-sm p-4 rounded-4 bg-white h-100 d-flex flex-column align-items-center justify-content-center position-relative hover-shadow">
                  <div className="icon-wrap d-flex align-items-center justify-content-center rounded-circle mb-3">
                    <img
                      src={`${PUBLIC_BASE_URL}${stat.icon}`}
                      alt={`rating-icon-${index + 1}`}
                      className="img-fluid"
                    />
                  </div>
                  <div className="stat-text">
                    <h3 className="fw-bold">{stat.number}</h3>
                    <p className="text-muted mb-0">{stat.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="contact-section py-5">
        <div className="container">
          <div className="row g-5 align-items-stretch">
            {/* Left: Contact Form */}
            <div className="col-lg-6 d-flex">
              <div className="p-4 bg-light rounded shadow w-100 h-100 d-flex flex-column justify-content-between">
                <div>
                  <p className="section-subtitle text-primary fw-bold">
                    — Get in touch
                  </p>
                  <h2 className="section-title mb-4">Reach Out to us!</h2>

                  <form
                    onSubmit={handleSubmit}
                    className="p-4 bg-light rounded shadow w-100"
                  >
                    <div className="mb-3 mt-5">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        required
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 mt-5">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 mt-5">
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Phone"
                        required
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 mt-5">
                      <select
                        className="form-select"
                        name="city"
                        required
                        value={formData.city}
                        onChange={handleChange}
                      >
                        <option value="">Select City</option>
                        <option value="Adelaide" selected>
                          {" "}
                          Adelaide
                        </option>
                        {/* <option value="Melbourne">Melbourne</option> */}
                      </select>
                    </div>
                    <div className="mb-3 mt-5">
                      {/* <input
                        // ref={inputRef}
                        type="text"
                        className="form-control"
                        placeholder="Address"
                        required
                        name="address"
                        value={formData.address || ""}
                        onChange={handleChange}
                      /> */}
                       <OpenCageAutocomplete
                            type="text"
                        className="form-control"
                        placeholder="Address"
                        required
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3 mt-5">
                      <textarea
                        className="form-control"
                        placeholder="Message (optional)"
                        rows="4"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                    <div className="mb-3 mt-5">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="What is 6 + 4?"
                        required
                        name="captcha"
                        value={formData.captcha}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button> */}

                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                    <SuccessPopup 
  isVisible={showSuccessPopup}
  onClose={() => setShowSuccessPopup(false)}
  message="Thank you! Your form has been submitted successfully. We'll get back to you soon!"
/>

                    {/* Toast container for notifications */}
                    <ToastContainer position="top-right" autoClose={3000} />
                  </form>
                </div>
              </div>
            </div>

            {/* Right: Stacked Maps */}
            <div className="col-lg-6 d-flex">
              <div className="w-100 h-100 d-flex flex-column justify-content-between">
                <h4 className="text-start mb-4" style={{ color: "#001070" }}>
                  📍 Explore Our Locations
                </h4>

                {/* Adelaide Map */}
                <div
                  className="card mb-4 border-0 shadow-lg rounded-4 overflow-hidden location-card"
                  style={{ background: "#f8f9fa" }}
                >
                  <iframe
                    className="w-100"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d104749.5741050878!2d138.678256!3d-34.870693!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa635f2ddcbe88963%3A0x4a7a383a4f425b24!2sShiny%20Cleaning!5e0!3m2!1sen!2sin!4v1750331328097!5m2!1sen!2sin"
                    title="Adelaide Office"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    style={{ height: "300px", border: 0 }}
                  ></iframe>
                  <div className="p-3">
                    <h5 className="text-dark fw-semibold mb-1">
                      🏢{" "}
                      <span style={{ color: "#001070" }}>Adelaide Office</span>
                    </h5>
                    <p className="mb-1 text-muted">📍 Para Hills, SA 5096</p>
                  </div>
                </div>

                {/* Melbourne Map - Hidden
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden location-card"
                  style={{ background: "#f8f9fa" }}
                >
                  <iframe
                    className="w-100"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d104749.5741050878!2d138.678256!3d-34.870693!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa635f2ddcbe88963%3A0x4a7a383a4f425b24!2sShiny%20Cleaning!5e0!3m2!1sen!2sin!4v1750331328097!5m2!1sen!2sin"
                    title="Melbourne Office"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    style={{ height: "300px", border: 0 }}
                  ></iframe>
                  <div className="p-3">
                    <h5 className="text-dark fw-semibold mb-1">
                      🏢{" "}
                      <span style={{ color: "#001070" }}>Melbourne Office</span>
                    </h5>
                    <p className="mb-1 text-muted">📍 Brunswick, VIC 3056</p>
                  </div>
                </div>
                */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <div className="container">
          <div className="section-header text-center mb-4">
            <p className="subheading">— Testimonials</p>
            <h2>Client Testimonies: Experience with Our Cleaners</h2>
          </div>

          <div className="row">
            {/* Left Summary */}
            <div className="col-lg-3 col-md-4 mb-4 text-center review-summary">
              <p className="rating-label m-0 fw-bold fs-5">EXCELLENT</p>
              <div className="stars">{renderStars(5)}</div>
              <p>
                Based on{" "}
                <strong>{reviewCount !== null ? reviewCount : "..."}</strong>{" "}
                reviews
              </p>
              <img
                src={Google}
                alt="Google"
                style={{ width: "100px", marginTop: "-10px" }}
              />
            </div>

            {/* Testimonials Scrollable */}
            <div className="col-lg-9 col-md-8 position-relative testimonial-scroll-wrapper">
              <div className="testimonial-scroll d-flex" ref={scrollRef}>
                {testimonials.map((item, index) => (
                  <div
                    key={index}
                    className="testimonial-card p-3 mx-2 bg-white rounded shadow"
                  >
                    <div className="card-header d-flex align-items-center mb-2">
                      {item.avatar ? (
                        <img
                          src={`${PUBLIC_BASE_URL}${item.avatar}`}
                          className="avatar-img me-2 rounded-circle"
                          alt={item.name}
                          style={{ width: 40, height: 40 }}
                        />
                      ) : (
                        <div className="avatar me-2">
                          {item.name?.charAt(0)}
                        </div>
                      )}
                      <div>
                        <h5 className="mb-0">{item.name}</h5>
                        <small>{item.date}</small>
                      </div>
                      <img
                        src={`${PUBLIC_BASE_URL}${item.platform}`}
                        alt="Platform"
                        style={{ width: 16, marginLeft: "auto" }}
                      />
                    </div>

                    <div className="rating mb-2">
                      {renderStars(item.rating)}
                      {item.verified && (
                        <img
                          src={`${PUBLIC_BASE_URL}${item.verified}`}
                          alt="verified"
                          style={{
                            width: 16,
                            marginLeft: "6px",
                            verticalAlign: "middle",
                          }}
                        />
                      )}
                    </div>

                    <p className="comment-truncate m-0">{item.comment}</p>
                  </div>
                ))}
              </div>

              {/* Arrow Controls */}
              <div className="d-flex justify-content-center gap-2 scroll-controls">
                <button
                  onClick={() => scroll("left")}
                  className="scroll-arrow left-arrow"
                >
                  <FaChevronLeft />
                </button>
                <button
                  onClick={() => scroll("right")}
                  className="scroll-arrow right-arrow"
                >
                  <FaChevronRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
